import { i18n as _i18n } from "@lingui/core";
import { SECURED_ONE_CARD, CARD_REWARDS_MVP, CARD_TRIPLE_CASH_REWARDS, CARD_UNLIMITED_CASH_REWARDS, CARD_REWARDS_ELITE, CARD_TRIPLE_CASH_REWARDS_ZERO, CARD_TRIPLE_CASH_REWARDS_FOCUS, CARD_REWARDS_ELITE_EARLY_PAY, CARD_LIFE_REWARDS, CARD_LIFE_REWARDS_NO_HEALTH, CARD_TRAVEL_CASH_REWARDS, LENDING_TREE_GROW, CARD_LIFE_REWARDS_FOCUS, CARD_LIFE_REWARDS_FOCUS_WITH_ANNUAL_FEE, CARD_CREDIT_BUILDER, CARD_MYFIVE_CASH_REWARDS, CARD_MYFIVE_CASH_REWARDS_V2, CARD_CASH_REWARDS_WITH_AUTOPAY, CARD_REWARDS_MVP_WITH_ANNUAL_FEE, CARD_TRIPLE_CASH_REWARDS_WITH_ANNUAL_FEE, CARD_TRIPLE_CASH_REWARDS_FOCUS_WITH_ANNUAL_FEE, CARD_UNLIMITED_CASH_REWARDS_WITH_ANNUAL_FEE, CARD_REWARDS_ELITE_EARLY_PAY_WITH_ANNUAL_FEE, CARD_LIFE_REWARDS_WITH_ANNUAL_FEE, CARD_LIFE_REWARDS_NO_HEALTH_WITH_ANNUAL_FEE, CARD_MYFIVE_CASH_REWARDS_WITH_ANNUAL_FEE, CARD_MYFIVE_CASH_REWARDS_V2_WITH_ANNUAL_FEE, CARD_CASH_REWARDS_WITH_AUTOPAY_WITH_ANNUAL_FEE, ONE_CARD_SELECT, CARD_TRAVEL_CASH_BACK_REWARDS_SELECT, CARD_REWARDS_ELITE_WITH_ANNUAL_FEE, SECURED_ONE_CARD_CREDIT_BUILDER } from '../../constants/program-definition-code';
import { ONE_CARD_PROGRAM_DEFINITION_CODES } from '../../constants/pcl/program-definition-code';
const CARD = {
  DEFAULT: 'DEFAULT'
};
const CARD_DEFINITION = {
  ONE_CARD_SELECT: {
    codes: [ONE_CARD_SELECT],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "6UNfhQ",
      message: "Upgrade OneCard Select"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "6UNfhQ",
      message: "Upgrade OneCard Select"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "F4rDaw",
      message: "an Upgrade OneCard Select"
    }
  },
  UPGRADE_MONEY: {
    codes: [SECURED_ONE_CARD_CREDIT_BUILDER],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "xpUhau",
      message: "Upgrade Money\u2122"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "zFjS51",
      message: "Upgrade Money\u2122"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "pwmt9t",
      message: "an Upgrade Money\u2122"
    }
  },
  SECURED_ONE_CARD: {
    codes: [SECURED_ONE_CARD],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "fJ2ouh",
      message: "Secured OneCard"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "bM/IqO",
      message: "Upgrade OneCard"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "qYW326",
      message: "an Upgrade OneCard"
    }
  },
  ONE_CARD: {
    codes: ONE_CARD_PROGRAM_DEFINITION_CODES,
    shortNameDescriptor:
    /*i18n*/
    {
      id: "q7KTEh",
      message: "OneCard"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "bM/IqO",
      message: "Upgrade OneCard"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "qYW326",
      message: "an Upgrade OneCard"
    }
  },
  REWARDS_MVP_CARD: {
    codes: [CARD_REWARDS_MVP],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "Ip50a7",
      message: "Cash Rewards"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "Zk/H/3",
      message: "Upgrade Cash Rewards Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "W3Bc4+",
      message: "an Upgrade Cash Rewards Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  REWARDS_MVP_CARD_WITH_ANNUAL_FEE: {
    codes: [CARD_REWARDS_MVP_WITH_ANNUAL_FEE],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "dKfa12",
      message: "Cash Rewards Select"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "j8RxEN",
      message: "Upgrade Cash Rewards Select Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "KyS4UQ",
      message: "an Upgrade Cash Rewards Select Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  TRIPLE_CASH_REWARDS_CARD: {
    codes: [CARD_TRIPLE_CASH_REWARDS, CARD_TRIPLE_CASH_REWARDS_ZERO],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "FzXkEy",
      message: "Triple Cash Rewards"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "+jnD84",
      message: "Upgrade Triple Cash Rewards Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "/esICJ",
      message: "an Upgrade Triple Cash Rewards Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  TRIPLE_CASH_REWARDS_FOCUS_CARD: {
    codes: [CARD_TRIPLE_CASH_REWARDS_FOCUS],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "9IEezv",
      message: "Triple Cash Focus"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "xcB75r",
      message: "Upgrade Triple Cash Focus Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "jXID0t",
      message: "an Upgrade Triple Cash Focus Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  TRIPLE_CASH_REWARDS_CARD_WITH_ANNUAL_FEE: {
    codes: [CARD_TRIPLE_CASH_REWARDS_WITH_ANNUAL_FEE],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "1e+6fT",
      message: "Triple Cash Rewards Select"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "L7OD5e",
      message: "Upgrade Triple Cash Rewards Select Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "/SsgpP",
      message: "an Upgrade Triple Cash Rewards Select Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  TRIPLE_CASH_REWARDS_FOCUS_CARD_WITH_ANNUAL_FEE: {
    codes: [CARD_TRIPLE_CASH_REWARDS_FOCUS_WITH_ANNUAL_FEE],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "srFzCL",
      message: "Triple Cash Focus Select"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "8F5mFn",
      message: "Upgrade Triple Cash Focus Select Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "1qx7vr",
      message: "an Upgrade Triple Cash Focus Select Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  UNLIMITED_CASH_REWARDS_CARD: {
    codes: [CARD_UNLIMITED_CASH_REWARDS],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "PMomke",
      message: "Unlimited Cash Rewards"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "c7u+It",
      message: "Upgrade Unlimited Cash Rewards Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "QNBZLb",
      message: "an Upgrade Unlimited Cash Rewards Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  UNLIMITED_CASH_REWARDS_CARD_WITH_ANNUAL_FEE: {
    codes: [CARD_UNLIMITED_CASH_REWARDS_WITH_ANNUAL_FEE],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "XjO7IN",
      message: "Unlimited Cash Rewards Select"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "yr+XNY",
      message: "Upgrade Unlimited Cash Rewards Select Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "MkM9nk",
      message: "an Upgrade Unlimited Cash Rewards Select Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  REWARDS_ELITE_CARD: {
    codes: [CARD_REWARDS_ELITE, CARD_REWARDS_ELITE_EARLY_PAY],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "DpZAGh",
      message: "Cash Rewards Elite"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "peCJtt",
      message: "Upgrade Cash Rewards Elite Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "vMBs0i",
      message: "an Upgrade Cash Rewards Elite Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  REWARDS_ELITE_CARD_WITH_ANNUAL_FEE: {
    codes: [CARD_REWARDS_ELITE_WITH_ANNUAL_FEE, CARD_REWARDS_ELITE_EARLY_PAY_WITH_ANNUAL_FEE],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "+PrpKo",
      message: "Cash Rewards Elite Select"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "xU3itc",
      message: "Upgrade Cash Rewards Elite Select Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "u9RbPR",
      message: "an Upgrade Cash Rewards Elite Select Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  LIFE_REWARDS_CARD: {
    codes: [CARD_LIFE_REWARDS, CARD_LIFE_REWARDS_NO_HEALTH],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "bRbm7i",
      message: "Life Rewards"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "Vjrvl8",
      message: "Upgrade Life Rewards Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "g+QpM2",
      message: "an Upgrade Life Rewards Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  LIFE_REWARDS_CARD_WITH_ANNUAL_FEE: {
    codes: [CARD_LIFE_REWARDS_WITH_ANNUAL_FEE, CARD_LIFE_REWARDS_NO_HEALTH_WITH_ANNUAL_FEE],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "Ov2uM2",
      message: "Life Rewards Select"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "ZLqU2f",
      message: "Upgrade Life Rewards Select Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "SK2tve",
      message: "an Upgrade Life Rewards Select Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  LIFE_REWARDS_FOCUS_CARD: {
    codes: [CARD_LIFE_REWARDS_FOCUS],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "pKsmf6",
      message: "Life Rewards Focus"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "ekKquC",
      message: "Upgrade Life Rewards Focus Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "nh3IKh",
      message: "an Upgrade Life Rewards Focus Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  LIFE_REWARDS_FOCUS_CARD_WITH_ANNUAL_FEE: {
    codes: [CARD_LIFE_REWARDS_FOCUS_WITH_ANNUAL_FEE],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "3/evwh",
      message: "Life Rewards Focus Select"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "/ucdn0",
      message: "Upgrade Life Rewards Focus Select Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "GrLRwG",
      message: "an Upgrade Life Rewards Focus Select Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  TRAVEL_CASH_REWARDS_CARD: {
    codes: [CARD_TRAVEL_CASH_REWARDS],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "MbiME1",
      message: "Travel Rewards"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "RFVUz2",
      message: "Upgrade Travel Rewards Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "ZvRSn5",
      message: "an Upgrade Travel Rewards Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  TRAVEL_CASH_REWARDS_CARD_WITH_ANNUAL_FEE: {
    codes: [CARD_TRAVEL_CASH_BACK_REWARDS_SELECT],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "vIJwPm",
      message: "Travel Rewards Select"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "L68eW3",
      message: "Upgrade Travel Rewards Select Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "C6iw5n",
      message: "an Upgrade Travel Rewards Select Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  LENDING_TREE: {
    codes: [LENDING_TREE_GROW],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "LOxZDb",
      message: "LendingTree Win"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "bDhCXm",
      message: "LendingTree Win Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "fbhN58",
      message: "a LendingTree Win Card"
    }
  },
  SELECT_CARD: {
    codes: [CARD_CREDIT_BUILDER],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "0r08s/",
      message: "Select"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "tSCpK0",
      message: "Upgrade Select card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "4veq8y",
      message: "an Upgrade Select card"
    },
    legalDefinition: CARD.DEFAULT
  },
  MYFIVE_CASH_REWARDS_CARD: {
    codes: [CARD_MYFIVE_CASH_REWARDS],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "SjaVP9",
      message: "MyFive Cash Rewards"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "QKLDv6",
      message: "Upgrade MyFive Cash Rewards Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "7RKeWE",
      message: "an Upgrade MyFive Cash Rewards Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  MYFIVE_CASH_REWARDS_CARD_WITH_ANNUAL_FEE: {
    codes: [CARD_MYFIVE_CASH_REWARDS_WITH_ANNUAL_FEE],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "E7otXd",
      message: "MyFive Cash Rewards Select"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "tyCtpx",
      message: "Upgrade MyFive Cash Rewards Select Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "P05NZl",
      message: "an Upgrade MyFive Cash Rewards Select Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  MYFIVE_CASH_REWARDS_CARD_V2: {
    codes: [CARD_MYFIVE_CASH_REWARDS_V2],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "SjaVP9",
      message: "MyFive Cash Rewards"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "QKLDv6",
      message: "Upgrade MyFive Cash Rewards Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "7RKeWE",
      message: "an Upgrade MyFive Cash Rewards Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  MYFIVE_CASH_REWARDS_CARD_V2_WITH_ANNUAL_FEE: {
    codes: [CARD_MYFIVE_CASH_REWARDS_V2_WITH_ANNUAL_FEE],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "E7otXd",
      message: "MyFive Cash Rewards Select"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "tyCtpx",
      message: "Upgrade MyFive Cash Rewards Select Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "P05NZl",
      message: "an Upgrade MyFive Cash Rewards Select Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  CASH_REWARDS_WITH_AUTOPAY_CARD: {
    codes: [CARD_CASH_REWARDS_WITH_AUTOPAY],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "Ip50a7",
      message: "Cash Rewards"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "Zk/H/3",
      message: "Upgrade Cash Rewards Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "W3Bc4+",
      message: "an Upgrade Cash Rewards Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  CASH_REWARDS_WITH_AUTOPAY_CARD_WITH_ANNUAL_FEE: {
    codes: [CARD_CASH_REWARDS_WITH_AUTOPAY_WITH_ANNUAL_FEE],
    shortNameDescriptor:
    /*i18n*/
    {
      id: "dKfa12",
      message: "Cash Rewards Select"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "j8RxEN",
      message: "Upgrade Cash Rewards Select Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "KyS4UQ",
      message: "an Upgrade Cash Rewards Select Card"
    },
    legalDefinition: CARD.DEFAULT
  },
  DEFAULT: {
    shortNameDescriptor:
    /*i18n*/
    {
      id: "EJKfax",
      message: "Upgrade Card"
    },
    nameDescriptor:
    /*i18n*/
    {
      id: "EJKfax",
      message: "Upgrade Card"
    },
    nameWithArticleDescriptor:
    /*i18n*/
    {
      id: "q6CvUN",
      message: "an Upgrade Card"
    }
  }
};
const findCardDefinition = code => {
  const cardDefinitionKey = Object.keys(CARD_DEFINITION).find(key => CARD_DEFINITION[key].codes?.includes(code));
  return CARD_DEFINITION[cardDefinitionKey] || CARD_DEFINITION.DEFAULT;
};
export const getCardNameDescriptor = ({
  code,
  withArticle = false,
  displayLegalName = true,
  displayShortName = false
}) => {
  let cardDefinition = findCardDefinition(code);
  if (displayLegalName && cardDefinition.legalDefinition) {
    cardDefinition = CARD_DEFINITION[cardDefinition.legalDefinition];
  }
  if (displayShortName) {
    return cardDefinition.shortNameDescriptor;
  }
  return withArticle ? cardDefinition.nameWithArticleDescriptor : cardDefinition.nameDescriptor;
};
const formatCardName = ({
  code,
  withArticle,
  displayLegalName,
  displayShortName
}) => {
  return _i18n._(getCardNameDescriptor({
    code,
    withArticle,
    displayLegalName,
    displayShortName
  }));
};
export default formatCardName;
//# sourceMappingURL=card-name.js.map